<template>
  <PageHeadlineSectionTitle :title="title" :class="{ required }" />
</template>

<script>
import PageHeadlineSectionTitle from '../../atoms/headlines/PageHeadlineSectionTitle.vue'

export default {
  components: {
    PageHeadlineSectionTitle
  },
  props: {
    title: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>
<style lang="scss" scoped>
.required::after {
  font-size: 1.8rem;
  font-weight: 700;
  line-height: 1.6;
  padding-left: 0.2rem;
  content: '*';
  color: $danger;
}
</style>
